const EMAIL_REGEXP = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
const LOGIN_REGEXP = /^[a-z0-9_-]{3,16}$/;

export const isEmail = (mail) => EMAIL_REGEXP.test(mail);

export const isLogin = (login) => LOGIN_REGEXP.test(login);
